import apiService from '@/services/apiService';

const actions = {
  getBanner({ commit }, payload) {
    apiService.get(`mitrapaxel-banner/find-one`)
      .then((response) => {
        commit('getBanner', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('mitrapaxel-banner/insert-or-update', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
